import { SkeletonBodyCopy, SkeletonHeadline } from '@xing-com/skeleton';

//TODO: adapt skeleton once xinglet content is finished
export const MatchingSkillsSkeleton: React.FC = () => (
  <>
    <SkeletonHeadline />
    <SkeletonBodyCopy />
  </>
);
